module.exports = __webpack_public_path__ + "static/logo-7851f9aea605315a2a060a514f6f5645.svg";